// @flow
import Component from './component'
export default () => ({
  path: 'account-statements',
  element: <Component />,
})
